import { render, staticRenderFns } from "./newGameUnclaimed.vue?vue&type=template&id=45ecb9ac&"
import script from "./newGameUnclaimed.vue?vue&type=script&lang=js&"
export * from "./newGameUnclaimed.vue?vue&type=script&lang=js&"
import style0 from "spinkit/spinkit.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./newGameUnclaimed.vue?vue&type=style&index=1&id=45ecb9ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports